import { apiClient } from '@/config/api';

export type LogementsSupervisionStatus = 'all' | 'online' | 'offline';

export type LogementsSupervisionItem = {
  apartment: { id: number; name: string; code: string | null; number: string | null };
  floor: { id: number; name: string; code: string | null };
  building: { id: number; name: string; code: string | null };
  box: { id: number | null; name: string | null; isOnline: boolean | null };
  thermostat: {
    deviceId: number | null;
    deviceName: string | null;
    isOnline: boolean | null;
    enabled: boolean;
    modeValue: number | null;
    modeLabel: string;
  };
  metrics: {
    tempInterieur: number | null;
    /** True when the raw sensor reading was outside the plausible range [7, 36]°C and has been clamped for display. */
    tempInterieurOutOfRange: boolean;
    tempInterieurAttrId: number | null;
    tempConsigne: number | null;
    tempConsigneAttrId: number | null;
    humidity: number | null;
    humidityAttrId: number | null;
    position: 'Ouverte' | 'Fermée';
    operatingStateAttrId: number | null;
    manoeuvres: number | null;
  };
};

export type BuildingEquipmentStats = {
  buildingId: number;
  boxOnline: number;
  boxOffline: number;
  thermostatOnline: number;
  thermostatOffline: number;
};

export type LogementsSupervisionResponse = {
  page: number;
  itemsPerPage: number;
  totalItems: number;
  items: LogementsSupervisionItem[];
  /** Equipment online/offline counts per building, computed on the full area subtree (not only apartment-linked equipment). */
  buildingsEquipment?: BuildingEquipmentStats[];
};

export const logementsService = {
  async getSupervision(params: {
    projectId: number;
    buildingId?: number | null;
    floorId?: number | null;
    apartmentId?: number | null;
    status?: LogementsSupervisionStatus;
    page?: number;
    itemsPerPage?: number;
  }): Promise<LogementsSupervisionResponse> {
    const { projectId, buildingId, floorId, apartmentId, status = 'all', page = 1, itemsPerPage = 200 } = params;
    const res = await apiClient.get<LogementsSupervisionResponse>(`/projects/${projectId}/logements/supervision`, {
      params: {
        buildingId: buildingId ?? undefined,
        floorId: floorId ?? undefined,
        apartmentId: apartmentId ?? undefined,
        status,
        page,
        itemsPerPage,
      },
    });
    return res.data;
  },
};

